import PropTypes from "prop-types"
import React, { useContext, useEffect, useRef } from "react"
import { Margin } from "styled-components-spacing"

import { trackLink } from "../utils/analytics"
import { ButtonAnchor } from "./atoms/Buttons"
import { H2 } from "./atoms/Headings"
import { Link } from "./atoms/Link"
import { VisitorLocaleContext } from "./providers/VisitorLocaleProvider"
import { HR } from "./Typography"

const baseURL = require("../settings/siteConfig").siteUrl

export const SigninModalContent = props => {
  const { karbonData } = useContext(VisitorLocaleContext)

  // https://app.karbonhq.com/public/#/login?returnUrl=https:%2f%2fkarbonhq.com%2freferal
  const RETURN_URL =
    typeof window !== "undefined"
      ? "?returnUrl=" + encodeURIComponent(`${baseURL}/add/${props.slug}`)
      : ""

  let appBaseUrl = `https://${
    process.env.GATSBY_DEPLOY_ENV === "live" ? "app" : "stage"
  }.karbonhq.com`

  if (karbonData?.data?.dataCenterUrl) {
    appBaseUrl = karbonData.data.dataCenterUrl
  }

  const SIGNIN_URL = `${appBaseUrl}/public/#/login/${RETURN_URL}`
  const getStartedButtonRef = useRef<HTMLAnchorElement>(null)
  useEffect(
    function trackGetStartedClick() {
      if (getStartedButtonRef.current) {
        return trackLink(getStartedButtonRef.current, "WE-GetStartedClicked")
      }
    },
    [getStartedButtonRef]
  )

  return (
    <div
      style={{
        textAlign: "center",
      }}
    >
      <H2 mt={0} centered>
        {props.loginTitle || `Login to Karbon`}
      </H2>

      {props.loginText}
      <Margin top={3} bottom={4}>
        <ButtonAnchor size={2} href={SIGNIN_URL} upperCase>
          Login
        </ButtonAnchor>
      </Margin>
      <HR height={2} mb={5} color={"lightGrey"} />
      <H2 mt={0} mb={1} centered>
        {props.trialTitle || `Book a call to set up your trial`}
      </H2>

      {props.trialText}

      <Link
        pink
        underlined
        href={"https://karbonhq.com/get-started?utm_source=template-library"}
        ref={getStartedButtonRef}
      >
        Get Started
      </Link>
    </div>
  )
}
SigninModalContent.propTypes = {
  loginTitle: PropTypes.string,
  loginText: PropTypes.node,
  trialTitle: PropTypes.string,
  trialText: PropTypes.node,
  slug: PropTypes.string.isRequired,
}
